export default __webpack_public_path__ + "static/media/LineBTN-round-default.9dc2ef97.svg";